import React from "react";

const DeliveryPolicy = () => {
  return (
    <div className="py-5">
      <div className="container px-md-5">
        <h2 className="mb-0 ff_heebo fw-bold fs_6xl clr_dark_green">
          Delivery Policy
        </h2>
        <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green mt-4">
          YOUR ORDER SHOULD BE DELIVERED WITHIN 5-7 WORKING DAYS
        </h3>
        <div>
          <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
            We offer free/paid shipping for all orders to be delivered within
            India. We usually ship orders within 2-3 days through our registered
            & reliable courier partners.
          </p>
          <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
            Delivery timelines are indicative and, on some occasions, there
            might be some delay due to unavoidable circumstances." If delivery
            or performance deadlines are not met for reasons beyond our control,
            such as force majeure or any other unforeseen event", that affects
            our component suppliers, the agreed deadlines shall be extended for
            a reasonable period. If there are multiple items, delivery might
            take some time.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPolicy;
